/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import {
    shape, string, func, bool, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import GraphqlPortalLoader from '../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import findContent from '../../gql/queries/findContent';
import { getBrand } from '../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import CGCModal from './Partials/CGCModal';
import { getCGCCardData } from '../../../state/ducks/App/App-Selectors';
import GraphlqlCelebrationsCustomsCard from './Partials/CustomLabels/GraphlqlCelebrationsCustomsCard';
import { brandByCode } from '../Checkout/containers/CheckoutFood/components/Partials/Helper/Helper';

const CelebrationsGreetingCard = ({
    brand,
    closeModal,
    openModal,
    existingCgcData,
    cartItemId,
    isCelebrationsCustomsCard,
    personalizationCustomsType,
    productSku,
    updateCGCCustomsData,
    customCardData,
    setOpenGreetingMessage,
    setCGCLabelData,
}) => {
    if (!openModal || !cartItemId) {
        return null;
    }

    const [brandCode] = (productSku || '')?.split('-');
    const [copyOfData, setCopyOfData] = useState(null);
    const productParentBrand = brandByCode?.[brandCode] || brand?.domain;

    const query = `{\\"brand\\": \\"${productParentBrand}\\"}`;
    const BRAND_DATA_QUERY = findContent({
        brand: 'gci',
        contentType: 'brands',
        reference: 'occasions_rank.occasions.reference',
        query,
    });
    const { data, error, loading } = useQuery(BRAND_DATA_QUERY);

    useEffect(() => {
        if (data) {
            setCopyOfData(JSON.parse(JSON.stringify(data)));
        }
    }, [data, setCopyOfData]);

    if (loading) {
        return <GraphqlPortalLoader />;
    }

    if (error || !data) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: BRAND_DATA_QUERY,
            component: 'GraphqlBrandDataContainer.js',
            message: `Failed to fetch content data for: content type brands,query ${query} on brand gci`,
            error,
        });
        return null;
    }

    // below if temporary due to apollo upgrade -> immuatable objects break current implementation of assigning
    // variables and properties to object returned from apollo
    if (!copyOfData) return null;

    // get occasion array of brand
    // Checks if data already exists and pass the data to editCard.
    // If no existing data then value will be null to avoid running the code
    if (copyOfData?.findContent?.content?.entries?.[0]) {
        // returns current brand data from array of entries to filter cards
        const getBrandData = (arr) => {
            const brandIdent  = arr.find((obj) => (obj.brand === productParentBrand));
            return brandIdent;
        };
        const brandData = getBrandData(copyOfData.findContent.content.entries) || copyOfData.findContent.content.entries[0];

        let editCard = {};
        if (existingCgcData?.length) {
            editCard = existingCgcData?.find((cgcData) => cgcData?.orderItemId === cartItemId);
        }

        if (isCelebrationsCustomsCard) {
            return (
                <GraphlqlCelebrationsCustomsCard
                    brandUid={brandData.uid}
                    cartItemId={cartItemId}
                    personalizationCustomsType={personalizationCustomsType}
                    closeModal={closeModal}
                    openModal={openModal}
                    updateCGCCustomsData={updateCGCCustomsData}
                    customCardData={customCardData}
                    setCGCLabelData={setCGCLabelData}
                />
            );
        }

        if (brandData) {
            return (
                <CGCModal
                    editCard={editCard}
                    brand={brand}
                    brandData={brandData}
                    cartItemId={cartItemId}
                    brandUid={brandData.uid}
                    openModal={openModal}
                    closeModal={closeModal}
                    occasionData={brandData.occasions_rank}
                    isCelebrationsCustomsCard={isCelebrationsCustomsCard}
                    personalizationCustomsType={personalizationCustomsType}
                    productSku={productSku}
                    updateCGCCustomsData={updateCGCCustomsData}
                    setOpenGreetingMessage={setOpenGreetingMessage}
                />
            );
        }
    }
    return null;
};

CelebrationsGreetingCard.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    closeModal: func.isRequired,
    productSku: string,
    openModal: bool.isRequired,
    cartItemId: string.isRequired,
    existingCgcData: arrayOf(
        shape({
            cartItemId: string,
        }),
    ).isRequired,
    isCelebrationsCustomsCard: bool.isRequired,
    personalizationCustomsType: string.isRequired,
    updateCGCCustomsData: func.isRequired,
    customCardData: shape({
        thumbnail: string,
    }),
    setOpenGreetingMessage: func.isRequired,
    setCGCLabelData: func.isRequired,
};

CelebrationsGreetingCard.defaultProps = {
    productSku: '',
    customCardData: {},
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    existingCgcData: getCGCCardData(state),
});
export default connect(mapStateToProps)(CelebrationsGreetingCard);
